export default "https://cdn-gra-staging.amplement.io/statics/images/shortlogo.png";